import PropTypes from 'prop-types';
import { Reply } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';

export default function Feedback({ feedback, openFeedback, setOpenFeedback }) {
  const handleOpenGmailCompose = () => {
    window.open(`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${feedback && feedback.email}`, '_blank');
  };
  return (
    <Dialog open={openFeedback} onClose={() => setOpenFeedback(false)}> 
      <Box sx={{ minWidth: 500, p: 2, backgroundColor: (theme) => theme.palette.mode === 'light' ? '#F9F9FB' : '#272424' }}>
        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
          <Typography variant="body1" sx={{ color: 'darkgray' }}>
            {feedback && feedback.name}
          </Typography>
          <Typography variant="body1" sx={{ minWidth: 80, textAlign: 'left', pl: 1 }}>
            {' '}
            : ስም
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
          <Typography variant="body2" sx={{ color: 'darkgray' }}>
            {feedback && feedback.email}
          </Typography>
          <Typography variant="body2" sx={{ minWidth: 80, textAlign: 'left', pl: 1 }}>
            {' '}
            : ኢሜል
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'left' }}>
          <Typography variant="body1" sx={{ minWidth: 80, textAlign: 'right', pr: 1 }}>
            ርዕሰ ጉዳይ ፡{' '}
          </Typography>
          <Typography variant="body1" sx={{ color: 'darkgray' }}>
            {feedback && feedback.subject}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'left' }}>
          <Typography variant="body2" sx={{ minWidth: 80, textAlign: 'right', pr: 1 }}>
            መልዕክት ፡{' '}
          </Typography>
          <Typography variant="body2" sx={{ color: 'gray' }}>
            {feedback && feedback.message}
          </Typography>
        </Box>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpenFeedback(false)}>
            ተመለስ
          </Button>
          <Tooltip title="መልስ ስጥ">
            <IconButton onClick={() => handleOpenGmailCompose()}>
              <Reply sx={{ transform: 'scaleX(-1)' }} />
            </IconButton>
          </Tooltip>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

// PropTypes validation
Feedback.propTypes = {
  feedback: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string
  }),
  openFeedback: PropTypes.bool.isRequired,
  setOpenFeedback: PropTypes.func.isRequired
};
